import {store} from '@/store'

let webSocketsService = {}

webSocketsService.install = function (Vue, options) {
  let ws= {}
  let reconnectInterval = options.reconnectInterval || 1000

  Vue.prototype.$webSocketsConnect = () => {
    const token = localStorage.getItem('access_token')
    const scope = localStorage.getItem('scope')
    if (token && options.url) {
      ws = new WebSocket(`${options.url}?token=${token}&scope=${scope}`)
      ws.onopen = () => {


        reconnectInterval = options.reconnectInterval || 1000
      }

      ws.onmessage = (event) => {

        handleNotification(event)
      }

      ws.onclose = (event) => {

        if (event) {

          if (event.code !== 1000) {
            let maxReconnectInterval = options.maxReconnectInterval || 3000
            setTimeout(() => {
              if (reconnectInterval < maxReconnectInterval) {

                reconnectInterval += 1000
              }
              Vue.prototype.$webSocketsConnect()
            }, reconnectInterval)
          }
        }
      }

      ws.onerror = (error) => {
        console.log(error)
        ws.close()
      }
    }
  }

  Vue.prototype.$webSocketsDisconnect = () => {

    ws.close()
  }

  Vue.prototype.$webSocketsSend = (data) => {

    ws.send(JSON.stringify(data))
  }

  function handleNotification (event) {
    const params = JSON.parse(event.data)
    if(params.type === 'update') {
      switch (params.data) {
        case 'messages':
          store.dispatch('setUserInfo')
          store.dispatch('setHaveNewMessage', true)
          break

        case 'accounts':
          store.dispatch('setHaveAccountsUpdate', true)
          break

        case 'docs':
          store.dispatch('setUserInfo')
          store.dispatch('setHaveNewDocs', true)
          break
      }
    }
  }
}

export default webSocketsService
